import { useCallback } from "react"

export default function usePatientNavigationController({
  clinicId,
  navigate,
  setActiveClinicId
}) {
  const resolveClinicId = useCallback((patientClinicId) => {
    return patientClinicId && patientClinicId !== "ALL"
      ? patientClinicId
      : clinicId && clinicId !== "ALL"
        ? clinicId
        : null
  }, [clinicId])

  const openPatient = useCallback((patientId, patientClinicId, tab = "") => {
    if (!patientId) return

    const realClinicId = resolveClinicId(patientClinicId)
    const params = new URLSearchParams()

    if (realClinicId) {
      localStorage.setItem("odontoflow_clinic_id", realClinicId)
      setActiveClinicId(realClinicId)
      params.set("clinicId", realClinicId)
    }

    if (tab) {
      params.set("tab", String(tab).trim().toUpperCase())
    }

    const query = params.toString() ? `?${params.toString()}` : ""
    navigate(`/patients/${patientId}${query}`)
  }, [navigate, resolveClinicId, setActiveClinicId])

  const openPatientFromAgenda = useCallback((patientId, patientClinicId, tab = "") => {
    openPatient(patientId, patientClinicId, tab)
  }, [openPatient])

  const openPatientFromActionPanel = useCallback((patientId, patientClinicId, tab = "") => {
    openPatient(patientId, patientClinicId, tab)
  }, [openPatient])

  return {
    openPatient,
    openPatientFromAgenda,
    openPatientFromActionPanel
  }
}
